import {Component} from "vue-property-decorator";
import BaseMixin from "@pazion/pazion-core/src/mixins/base.mixin";
import EntityLogDialog from "@pazion/pazion-core/src/components/utils/EntityLogDialog.vue";

/**
 * This component requires, a ref 'entityLogDialog' be set to the EntityLogDialog component
 */
@Component
export default class EntityLogMixin extends BaseMixin {

    protected defaultEntityType = 'entity';

    $refs!: {
        "entityLogDialog": EntityLogDialog
    }

    public async showEntityLogDialog(id: number | string, type: string | undefined) {
        type = type || this.defaultEntityType;
        await this.$refs.entityLogDialog.showDialog(id, type);
    }
}